//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../../EventBus/EventBus.js'
import { formatTime } from '../../../components/helpers.js'

import { formatTrueFalse, getTagByKey } from './ReportMaterialsHelperFunctions.js'
import ReportMaterialsTable from './ReportMaterialsTable.vue'
import ReportMaterialsDemountingEditor from './ReportMaterialsDemountingEditor.vue'
import ReportRemarkImportantCheckbox from '../ReportRemarkImportantCheckbox.vue'

export default {
  components: {
    ReportMaterialsTable,
    ReportRemarkImportantCheckbox
  },
  props: {
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    debits: {
      type: Array,
      default () {
        return []
      }
    },
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    reportId: {
      type: Number,
      default: 0
    },
    checking: {
      type: Boolean,
      default: false
    },
    isGeneralDemounting: {
      type: Boolean,
      default: false
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      updateSegmentHandler: null,
      selectedItemsLength: 0,

      serviceObjectDefault: {},

      columns: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'toolKey',
          label: 'ID номенклатурной позиции в 1С',
          align: 'left',
          field: 'toolKey',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: 'amount',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          sortable: true
        },
        {
          name: 'nomName',
          label: 'Номенклатура',
          align: 'left',
          field: 'nomName',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'reportPaths',
          label: 'Отчет',
          align: 'left',
          field: 'reportPaths',
          sortable: true,
          defaultWidth: 200
        },
        {
          name: 'sn',
          label: 'Серийный номер',
          align: 'left',
          field: 'sn',
          sortable: true
        },
        {
          name: 'serviceObjectName',
          label: 'Объект обслуживания',
          align: 'left',
          field: 'serviceObjectName',
          sortable: true
        },
        {
          name: 'brigadeName',
          label: 'Бригада',
          align: 'left',
          field: 'brigadeName',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'tag',
          label: 'Тег',
          align: 'left',
          field: 'tag',
          format: tag => getTagByKey(tag, this.tags),
          sortable: true,
          defaultWidth: 100
        },
        {
          name: 'noted',
          label: 'Результат проверки',
          align: 'left',
          field: 'noted',
          sortable: true
        },
        {
          name: 'note',
          label: 'Замечание аналитика',
          align: 'left',
          field: 'note',
          sortable: true
        },
        {
          name: 'changed',
          label: 'Изменено',
          align: 'left',
          field: 'changed',
          sortable: true,
          format: formatTrueFalse,
          defaultWidth: 100
        },
        {
          name: 'time',
          label: 'Дата/время',
          align: 'left',
          field: 'time',
          sortable: true,
          format: formatTime,
          defaultWidth: 150
        },
        {
          name: 'user',
          label: 'Сотрудник',
          align: 'left',
          field: 'user',
          sortable: true,
          defaultWidth: 200
        }
      ]
    }
  },
  created: function () {
    this.updateSegmentHandler = (data) => {
      if (this.isGeneralDemounting || this.report.key !== data.reportKey) {
        return
      }

      const selectedSegment = data.segment

      if (data.operation.type === 'delete') {
        const row = this.demountings.find(demounting => demounting.recId === selectedSegment.demountingId)
        this.onDeleteDemounting(row)
      } else {
        if (selectedSegment.demountingId) {
          const row = this.demountings.find(mounting => mounting.recId === selectedSegment.demountingId)
          this.onEditDemounting(row, selectedSegment)
        } else {
          this.onAddDemounting(null, selectedSegment)
        }
      }
    }

    EventBus.$on('demounting-segment', this.updateSegmentHandler)
  },
  beforeDestroy: function () {
    EventBus.$off('demounting-segment', this.updateSegmentHandler)
  },
  methods: {
    onSelectedItems: function (selectedItemsLength) {
      this.selectedItemsLength = selectedItemsLength
    },
    onAddDemounting: function (operation, selectedSegment) {
      const serviceObject = this.serviceObjectDefault && this.serviceObjectDefault.id ? this.serviceObjectDefault : this.serviceObject

      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsDemountingEditor,
        contentProps: {
          record: null,
          isEdit: false,
          operation: operation,
          // ===
          serviceObjectDefault: serviceObject,
          isGeneralDemounting: this.isGeneralDemounting,
          // ===
          materialesAvailable: this.materialesAvailable,
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          reportRoles: this.reportRoles
        },
        componentHandlers: {
          save: (demounting) => {
            dialog.hide()
            this.onSaveAddDemounting(demounting, operation, selectedSegment)
          },
          close: () => {
            dialog.hide()
          }
        }
      })
    },
    onAddRemark: function () {
      if (this.report.demountingRemarks.length === 0) {
        this.report.demountingRemarks.push({
          active: true,
          code: 'demountingRemarks',
          comment: null,
          important: false
        })
      } else {
        this.report.demountingRemarks[0].active = true
      }
    },
    onDeleteRemark: function () {
      if (this.report.demountingRemarks.length !== 0) {
        this.report.demountingRemarks[0].active = false
      }
    },
    onApproveSelectedDemountings: function () {
      this.$refs.reportMaterialsTable.$refs.reportMaterialsTableDispatcher.approveSelectedItems()
    },
    onDeleteDemounting: function (row) {
      const index = this.demountings.indexOf(row)
      this.demountings.splice(index, 1) // TODO delete demounting

      const debit = this.debits.find(debit => debit.demountingId === row.recId)
      if (debit) {
        debit.demountingId = null
      }

      const consumption = this.consumptions.find(consumption => consumption.demountingId === row.recId)
      if (consumption) {
        consumption.demountingId = null
      }

      const mounting = this.mountings.find(mounting => mounting.demountingId === row.recId)
      if (mounting) {
        mounting.demountingId = null
        mounting.sourceTable = null
      }
    },
    onEditDemounting: function (record, selectedSegment) {
      const mounting = this.mountings.find(mounting => mounting.demountingId === record.recId)
      if (mounting) {
        this.$q.notify({
          type: 'negative',
          message: 'Редактирование запрещено. Редактируйте монтаж, который ссылается на данный демонтаж.',
          progress: true,
          timeout: 8000
        })

        return
      }

      const index = this.demountings.indexOf(record)
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        noWrap: true,
        contentWidth: 560,
        contentComponent: ReportMaterialsDemountingEditor,
        contentProps: {
          record: record,
          isEdit: true,
          operation: null,
          // ===
          consumptions: this.consumptions,
          mountings: this.mountings,
          demountings: this.demountings,
          projects: this.projects,
          tags: this.tags,
          report: this.report,
          reportActionsAccess: this.reportActionsAccess,
          reportRoles: this.reportRoles
        },
        componentHandlers: {
          save: (demounting) => {
            dialog.hide()
            this.onSaveEditDemounting(demounting, index, selectedSegment)
          },
          close: () => dialog.hide()
        }
      })
    },
    onSaveEditDemounting: function (demounting, index, selectedSegment) {
      const originalInitial = this.demountings[index] ? this.demountings[index]._initial : undefined
      demounting = JSON.parse(JSON.stringify(demounting)) // TODO new demounting

      if (selectedSegment) {
        demounting.isSegment = true
      }

      if (originalInitial !== undefined) {
        Object.defineProperty(demounting, '_initial', {
          value: originalInitial,
          writable: false,
          enumerable: false,
          configurable: true
        })
      }
      this.demountings.splice(index, 1, demounting) // TODO update demounting

      this.serviceObjectDefault.id = demounting.serviceObjectKey
      this.serviceObjectDefault.name = demounting.serviceObjectName
    },
    onSaveAddDemounting: function (demounting, operation, selectedSegment) {
      demounting = JSON.parse(JSON.stringify(demounting)) // TODO new demounting
      if (selectedSegment) {
        demounting.isSegment = true
      }

      demounting.recId = new Date().getTime()
      if (selectedSegment) {
        selectedSegment.demountingId = demounting.recId
      }
      this.demountings.push(demounting) // TODO add demounting

      if (operation === 'replacement') {
        this.$parent.$parent.$parent.$parent.$refs.mountings.onAddOperationMounting('replacement', demounting.recId)
      }
    }
  }
}

